export const languages = [
    { value: "en", label: "English (English)" },
    { value: "hi", label: "Hindi (हिन्दी)" },
    { value: "bn", label: "Bengali (বাংলা)" },
    { value: "ta", label: "Tamil (தமிழ்)" },
    { value: "te", label: "Telugu (తెలుగు)" },
    { value: "kn", label: "Kannada (ಕನ್ನಡ)" },
    { value: "ml", label: "Malayalam (മലയാളം)" },
    { value: "gu", label: "Gujarati (ગુજરાતી)" },
    { value: "mr", label: "Marathi (मराठी)" },
    { value: "or", label: "Odia (ଓଡ଼ିଆ)" },
    { value: "pa", label: "Punjabi (ਪੰਜਾਬੀ)" },
    { value: "as", label: "Assamese (অসমীয়া)" },
    { value: "ne", label: "Nepali (नेपाली)" },
    { value: "sd", label: "Sindhi (सिन्धी)" },
    { value: "ks", label: "Kashmiri (कश्मीरी)" },
    { value: "doi", label: "Dogri (डोगरी)" },
    { value: "kok", label: "Konkani (कोंकणी)" },
    { value: "mai", label: "Maithili (मैथिली)" },
    { value: "sa", label: "Sanskrit (संस्कृतम्)" },
    { value: "sat", label: "Santali (संताली)" },
    { value: "brx", label: "Bodo (बोड़ो)" },
    { value: "mni", label: "Manipuri (মণিপুরী)" },
];
